<svg id="Ebene_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.04 79.11"
    ><defs
        ><style>
            .cls-1 {
                fill: #1d1d1b;
            }
        </style></defs
    ><g id="Ebene_1-2"
        ><g
            ><path
                class="cls-1"
                d="M73,79.11H18.62c-.97,0-1.75-.78-1.75-1.75v-18.43c0-.97,.78-1.75,1.75-1.75h54.38c.97,0,1.75,.78,1.75,1.75v18.43c0,.97-.78,1.75-1.75,1.75Zm-52.63-3.5h50.88v-14.93H20.37v14.93Z"
            /><g
                ><g
                    ><path
                        class="cls-1"
                        d="M20.17,21.93H1.75c-.97,0-1.75-.78-1.75-1.75V1.75C0,.78,.78,0,1.75,0H20.17c.97,0,1.75,.78,1.75,1.75V20.18c0,.97-.78,1.75-1.75,1.75ZM3.5,18.43h14.92V3.5H3.5v14.93Z"
                    /><path
                        class="cls-1"
                        d="M10.96,49.65c-.45,0-.9-.17-1.24-.51L1.71,41.12c-.68-.68-.68-1.79,0-2.47l8.02-8.02c.68-.68,1.79-.68,2.47,0l8.02,8.02c.68,.68,.68,1.79,0,2.47l-8.02,8.02c-.34,.34-.79,.51-1.24,.51Zm-5.54-9.77l5.54,5.54,5.54-5.54-5.54-5.54-5.54,5.54Z"
                    /></g
                ><path
                    class="cls-1"
                    d="M10.96,33.61c-.97,0-1.75-.78-1.75-1.75v-10.93c0-.97,.78-1.75,1.75-1.75s1.75,.78,1.75,1.75v10.93c0,.97-.78,1.75-1.75,1.75Z"
                /></g
            ><g
                ><path
                    class="cls-1"
                    d="M54.73,21.93h-18.43c-.97,0-1.75-.78-1.75-1.75V1.75c0-.97,.78-1.75,1.75-1.75h18.43c.97,0,1.75,.78,1.75,1.75V20.18c0,.97-.78,1.75-1.75,1.75Zm-16.68-3.5h14.93V3.5h-14.93v14.93Z"
                /><path
                    class="cls-1"
                    d="M45.52,49.65c-.45,0-.9-.17-1.24-.51l-8.02-8.02c-.68-.68-.68-1.79,0-2.47l8.02-8.02c.68-.68,1.79-.68,2.47,0l8.02,8.02c.68,.68,.68,1.79,0,2.47l-8.02,8.02c-.34,.34-.79,.51-1.24,.51Zm-5.54-9.77l5.54,5.54,5.54-5.54-5.54-5.54-5.54,5.54Z"
                /><path
                    class="cls-1"
                    d="M45.52,33.61c-.97,0-1.75-.78-1.75-1.75v-10.93c0-.97,.78-1.75,1.75-1.75s1.75,.78,1.75,1.75v10.93c0,.97-.78,1.75-1.75,1.75Z"
                /></g
            ><g
                ><path
                    class="cls-1"
                    d="M89.29,21.93h-18.43c-.97,0-1.75-.78-1.75-1.75V1.75c0-.97,.78-1.75,1.75-1.75h18.43c.97,0,1.75,.78,1.75,1.75V20.18c0,.97-.78,1.75-1.75,1.75Zm-16.68-3.5h14.93V3.5h-14.93v14.93Z"
                /><path
                    class="cls-1"
                    d="M80.07,49.65c-.45,0-.9-.17-1.24-.51l-8.02-8.02c-.68-.68-.68-1.79,0-2.47l8.02-8.02c.68-.68,1.79-.68,2.47,0l8.02,8.02c.68,.68,.68,1.79,0,2.47l-8.02,8.02c-.34,.34-.79,.51-1.24,.51Zm-5.54-9.77l5.54,5.54,5.54-5.54-5.54-5.54-5.54,5.54Z"
                /><path
                    class="cls-1"
                    d="M80.07,33.61c-.97,0-1.75-.78-1.75-1.75v-10.93c0-.97,.78-1.75,1.75-1.75s1.75,.78,1.75,1.75v10.93c0,.97-.78,1.75-1.75,1.75Z"
                /></g
            ><path
                class="cls-1"
                d="M45.52,60.3c-.97,0-1.75-.78-1.75-1.75v-10.66c0-.97,.78-1.75,1.75-1.75s1.75,.78,1.75,1.75v10.66c0,.97-.78,1.75-1.75,1.75Z"
            /><path
                class="cls-1"
                d="M37.5,41.63H18.98c-.97,0-1.75-.78-1.75-1.75s.78-1.75,1.75-1.75h18.52c.97,0,1.75,.78,1.75,1.75s-.78,1.75-1.75,1.75Z"
            /><path
                class="cls-1"
                d="M72.05,41.63h-18.52c-.97,0-1.75-.78-1.75-1.75s.78-1.75,1.75-1.75h18.52c.97,0,1.75,.78,1.75,1.75s-.78,1.75-1.75,1.75Z"
            /></g
        ></g
    ></svg
>
